<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><b><i class="fas fa-user-clock"></i> {{ "TITLE.TSA-CREDENTIALS" | translate }}</b></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="tsaCredentialForm">
      <div class="form-group">
        <label for="tsaprovider" class="font-weight-bold"><b>{{ "LABEL.PROVIDER" | translate }}</b></label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-user-tie"></i></div>
          </div>
          <select class="form-control"
                  id="tsaprovider"
                  formControlName="tsaprovider"
                  [(ngModel)]="tsacredential.tsaproviderId"
                  [class.is-invalid]="isInvalidControl('tsaprovider')">
            <option *ngFor="let tsaprovider of tsaproviders"
                    [ngValue]="tsaprovider.id">{{tsaprovider.description | translate}}</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label for="username" class="font-weight-bold"><b>{{ "LABEL.USER" | translate }}</b></label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-user"></i></div>
          </div>
          <input type="text"
                 id="username"
                 class="form-control"
                 placeholder="{{ 'MESSAGE.ENTER-USER' | translate }}"
                 [(ngModel)]="tsacredential.username"
                 formControlName="username"
                 [class.is-invalid]="isInvalidControl('username')">
        </div>
        <small *ngIf="isInvalidControl('username')"
               class="text-danger">
          {{ "MESSAGE.ENTER-USER" | translate }}
        </small>
      </div>
      <div class="form-group">
        <label for="password" class="font-weight-bold"><b>{{ "LABEL.PASSWORD" | translate }}</b></label>
        <div class="input-group">
          <input [type]="viewActualPassword ? 'text' : 'password'"
                 id="password"
                 class="form-control"
                 placeholder="{{ 'MESSAGE.ENTER-PASSWORD' | translate }}"
                 [(ngModel)]="tsacredential.password"
                 formControlName="password"
                 [class.is-invalid]="isInvalidControl('password')"
                 [attr.disabled]="editPassword ? '' : null">
          <div class="input-group-append">
        <span class="input-group-text">
        <i
          class="fa {{viewActualPassword?'fa-eye':'fa-eye-slash'}}"
          (click)="toggleFieldTextType()"
        ></i>
        </span>
          </div>
        </div>
        <div>
          <small *ngIf="isInvalidControl('password')"
                 class="text-danger">
            {{ "MESSAGE.ENTER-PASSWORD" | translate }}
          </small>
        </div>
      </div>
      <div class="form-row" style="float: right" [hidden]="disableEditPassword">
        <div class="form-group col-md-2 custom-align-center">
          <div class="custom-control custom-checkbox my-1 mr-sm-2">
            <input type="checkbox"
                   class="custom-control-input"
                   id="disablePasswordCheckbox"
                   [checked]="!editPassword"
                   (click)="disablePasswordControls($event)">
            <label class="custom-control-label" for="disablePasswordCheckbox">{{ "BUTTON.EDIT" | translate }}</label>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="url" class="font-weight-bold">URL</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-link"></i></div>
          </div>
          <input type="text"
                 id="url"
                 class="form-control"
                 placeholder="{{ 'MESSAGE.ENTER-URL' | translate }}"
                 [(ngModel)]="tsacredential.url"
                 formControlName="url"
                 [class.is-invalid]="isInvalidControl('url')">
        </div>
        <small *ngIf="isInvalidControl('url')"
               class="text-danger">
          {{ "MESSAGE.ENTER-URL" | translate }}
        </small>
      </div>
      <div class="row">
        <div class="col" *ngIf="!isNewTsacredential">
          <label for="state" class="col-form-label font-weight-bold">{{ "LABEL.STATE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="{{isActive ? 'input-group-text': 'input-group-text-danger' }}">
                <i class="{{isActive ? 'fas fa-toggle-on': 'fas fa-toggle-off' }}"></i></div>
            </div>
            <select class="form-control"
                    id="state"
                    formControlName="status"
                    [(ngModel)]="tsacredential.active"
                    [class.is-invalid]="isInvalidControl('status')">
              <option [value]="true">{{ "LABEL.ACTIVE" | translate }}</option>
              <option [value]="false">{{ "LABEL.INACTIVE" | translate }}</option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fas fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
